"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const ShortcutItem_scss_1 = __importDefault(require("./ShortcutItem.scss"));
function ShortcutItem({ name, value }) {
    return (react_1.default.createElement("div", { className: ShortcutItem_scss_1.default.shortcut },
        react_1.default.createElement("span", { className: ShortcutItem_scss_1.default.name }, name),
        react_1.default.createElement("span", { className: ShortcutItem_scss_1.default.value }, value)));
}
exports.default = ShortcutItem;
